// extracted by mini-css-extract-plugin
export default {"box":"Bz4+LTbfiQlzBINBASNk3w==","bar":"NFndPkrQJ1cUw9UA1W5UGw==","move":"_01qPQZL4cuS-jmgdzqBFkA=="};